export default "__VITE_ASSET__7a6111d4__"